import MenubarHeader from './MenubarHeader'
import MenubarInfo from './MenubarInfo'
import MenubarNav from './MenubarNav'
import { ICurriculumNavList } from '@/features/common/types'
import { LockIcon, LogOutIcon } from './Icons'
import Link from 'next/link'
import { HomeIcon } from '@heroicons/react/24/outline'
import { useRouter } from 'next/router'
interface IPcSidebarProps {
  navList: ICurriculumNavList[]
  gotoPage: (href: string) => void
  isActive: (href: string) => boolean
  logoImg: string | undefined
  name: string | undefined
  curriculumPeriod: string | number | undefined
}

const PcSidebar = ({
  navList,
  gotoPage,
  isActive,
  logoImg,
  name,
  curriculumPeriod,
}: IPcSidebarProps) => {
  const router = useRouter()
  const goToCourse = () => {
    router.push('/courses')
  }
  return (
    <aside className="hidden shrink-0 lg:block lg:w-[220px]">
      <div className="relative z-10 flex h-full flex-col items-stretch overflow-hidden bg-white px-4 py-6 shadow-[0_6px_12px_0_rgba(0,0,0,0.12)]">
        <MenubarHeader logoImg={logoImg} />
        <MenubarInfo name={name} curriculumPeriod={curriculumPeriod} />
        <div className="mt-3 flex flex-1 flex-col justify-between">
          <div className="flex flex-col gap-2">
            <MenubarNav navList={navList} gotoPage={gotoPage} isActive={isActive} />
            <div
              className="flex cursor-pointer items-center gap-3 border-t px-3 pt-4 text-label-alternative"
              onClick={goToCourse}
            >
              <HomeIcon className="w-5 self-start" />
              <p className="whitespace-nowrap text-base font-semibold">내 강의실로 가기</p>
            </div>
          </div>
          <ul>
            <li>
              <Link
                href={'/oauth/logout'}
                className="flex cursor-pointer flex-row items-center gap-3 text-label-alternative lg:px-3 lg:py-2.5"
              >
                <div className="h-5 w-5">
                  <LogOutIcon />
                </div>
                <span className="text-base font-semibold">로그아웃</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  )
}

export default PcSidebar
